export const EVENT_TEXT = 'text-sm leading-5 font-normal text-muted-foreground';
